import { getChannel, getContent } from '@lib/server';
import type { Offer, Page } from '@types';

export async function getBrandOffersParamData(domain: string) {
  const channel = await getChannel(domain);

  if (!channel?.channelId) return {};

  const offersPage = await getContent<Page>('pages')
    .setDepth(0)
    .setTags([channel.channelId])
    .setWhere([
      ['fields.pageSlug', 'eq', 'offers'],
      [
        'fields.brandPages',
        'contains',
        {
          linkType: 'Entry',
          id: channel.micrositeData[0].id,
          type: 'Link',
        },
      ],
      ['fields.template', 'eq', channel.theme],
    ])
    .fetch(['id']);

  // if there isn't a offers page, don't fetch offers
  if (!offersPage?.length) return {};

  const offers = await getContent<Offer>('promotionsAndOffers')
    .setDepth(0)
    .setTags([channel.channelId])
    .setWhere([
      [
        'fields.brandOffers',
        'contains',
        {
          linkType: 'Entry',
          id: channel.micrositeData[0].id,
          type: 'Link',
        },
      ],
    ])
    .fetch(['fields.details.slug']);

  return {
    offers: offers?.map(({ fields }) => ({ ...fields.details })) || [],
  };
}
